"use strict";
exports.__esModule = true;
exports.addMockForeignData = exports.getForeignEntityFields = exports.generateProjection = exports.isFieldForeignEntity = exports.renderEnum = exports.renderForeignEntity = exports.toOptionSet = exports.toUOptionSet = exports.getEntityByName = exports.mapTypes = void 0;
var utils_1 = require("../ui/form/select/utils");
exports.mapTypes = new Map([
    ['String', 'string'],
    ['BigDecimal', 'number'],
    ['LocalDate', 'date'],
    ['Int', 'number'],
    ['Boolean', 'boolean'],
    ['LocalDateTime', 'date'],
    ['Enum', 'enum']
]);
exports.getEntityByName = function (name, entities) {
    return entities.filter(function (e) { return e.name === name; })[0];
};
exports.toUOptionSet = function (d) { return ({
    uuid: d.uuid,
    name: d.label || d.name || d.uuid
}); };
exports.toOptionSet = function (d) { return ({
    id: d.id,
    name: d.label || d.name || String(d.id)
}); };
exports.renderForeignEntity = function (x, entity, foreignEntity) {
    var foreignEntityField = entity.fields.filter(function (f) { return f.type === foreignEntity.name; })[0];
    var obj = x[foreignEntityField.name];
    if (!obj)
        return '';
    if (obj.label || obj.name)
        return obj.label || obj.name;
    return foreignEntity.uuid ? obj.uuid : obj.id;
};
exports.renderEnum = function (x, name, options) {
    var selectedOption = options.filter(function (o) {
        if (utils_1.isUOptionSet(o)) {
            return o.uuid === x[name];
        }
        return o.id === x[name];
    });
    return selectedOption.length ? selectedOption[0].name : x[name] || '-';
};
exports.isFieldForeignEntity = function (field) {
    return !Boolean(exports.mapTypes.get(field.type));
};
exports.generateProjection = function (fields) {
    var projection = {};
    fields.forEach(function (f) {
        if (exports.isFieldForeignEntity(f)) {
            projection[f.name.toString()] = {};
        }
    });
    return projection;
};
exports.getForeignEntityFields = function (fields) {
    return fields.filter(function (f) { return exports.isFieldForeignEntity(f); });
};
exports.addMockForeignData = function (mockData, foreignEntityFields, entityMockData) {
    if (!entityMockData) {
        return mockData;
    }
    foreignEntityFields.forEach(function (field) {
        var _a;
        if (entityMockData[field.type] && ((_a = entityMockData[field.type].list) === null || _a === void 0 ? void 0 : _a.length)) {
            var item = entityMockData[field.type].list.find(function (foreignMockData) {
                return foreignMockData.uuid
                    ? foreignMockData.uuid ===
                        mockData[field.name].uuid
                    : foreignMockData.id === mockData[field.name].id;
            });
            mockData[field.name] =
                item || entityMockData[field.type].list[0];
        }
    });
    return mockData;
};
